'use client';

import { useQuery } from '@tanstack/react-query';
import { ComponentProps } from 'react';
import { QueryApi } from '@/features/query/api';
import { getFormatedPhoneNumber } from '@/shared/lib/getFormatedPhoneNumber';
import { Icon } from '@/shared/ui/icon';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;

const VenueTelephoneWrapper = ({ children, ...props }: Props) => {
    return (
        <Layout
            media={{
                ...props.media,
                initial: {
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 8,
                    alignItems: 'center',
                    ...props.media?.initial,
                },
            }}
            {...props}
        >
            {children}
        </Layout>
    );
};

const VenueTelephoneIcon = (props: Props) => {
    return (
        <Layout
            media={{ ...props.media, initial: { width: 24, height: 24, ...props.media?.initial } }}
            {...props}
        >
            <Icon name="phone" />
        </Layout>
    );
};

const VenueTelephoneText = () => {
    const venueQuery = useQuery(QueryApi.Venue.queries.Venue);

    const { href, formated: venuePhoneNumber } = getFormatedPhoneNumber(
        venueQuery.data?.contactInfo?.telephonePrefix || '',
        venueQuery.data?.contactInfo?.telephone || '',
    );

    return (
        <Layout element="a" href={href}>
            {venuePhoneNumber}
        </Layout>
    );
};

export { VenueTelephoneWrapper as Wrapper, VenueTelephoneIcon as Icon, VenueTelephoneText as Text };
